import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TextOnlyDirective } from '../core/directives/textOnly.directive';
import { NumberOnlyDirective } from '../core/directives/number.directive';
import { DecimalInputDirective } from '../core/directives/numberUpto2DecimalPlaces.directive';
import { PhoneNoLengthDirective } from '../core/directives/phone-no-length.directive';
import { AutoTooltipDirective } from '../core/directives/auto-tooltip.directive';
import { TestTooltipDirective } from '../core/directives/test-tooltip.directive';
import { NgxEditorModule } from 'ngx-editor';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';

@NgModule({
  declarations: [
    TextOnlyDirective,
    NumberOnlyDirective,
    DecimalInputDirective,
    PhoneNoLengthDirective,
    AutoTooltipDirective,
    TestTooltipDirective,
    SafeHtmlPipe
  ],
  imports: [CommonModule, RouterModule, MatTooltipModule, NgxEditorModule],
  exports: [
    TextOnlyDirective,
    NumberOnlyDirective,
    DecimalInputDirective,
    PhoneNoLengthDirective,
    AutoTooltipDirective,
    TestTooltipDirective,
    SafeHtmlPipe,
    MatTooltipModule,
    NgxEditorModule
  ]
})
export class SharedModule {}
